import { createSlice } from "@reduxjs/toolkit";
import { getBlogData, deleteBlogData } from "./ThunkAction";
import { REDUCER_NAME } from "./Types";

interface BlogState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: BlogState = {
  data: [],
  isLoading: false,
  error: null,
};

const blogSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetBlogState: () => {
      return initialState;
    },
  },
extraReducers: (builder) => {
  builder

    // ✅ GET BLOGS
    .addCase(getBlogData.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })

    .addCase(getBlogData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    })

    .addCase(getBlogData.rejected, (state, action) => {
      state.isLoading = false;
      // @ts-expect-error
      state.error = action.payload?.message || "Error fetching blogs";
    })

    // ✅ DELETE BLOG
    .addCase(deleteBlogData.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })

    .addCase(deleteBlogData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = state.data.filter(
        (blog) => blog.id !== action.payload.data
      );
    })

    .addCase(deleteBlogData.rejected, (state, action) => {
      state.isLoading = false;
      //@ts-ignore
      state.error = action.payload?.message || "Error deleting blog";
    });
}
});

export const { resetBlogState } = blogSlice.actions;

export default blogSlice.reducer;